document.addEventListener('DOMContentLoaded', function () {
  initPayLaterVisibilityOnHomeHero();

  function initPayLaterVisibilityOnHomeHero() {
    const heroBackground = document.querySelector('.main-page-hero-bg');
    if (!heroBackground || !document.body) {
      return;
    }

    const hideClass = 'home-hero-paylater-hidden';
    const togglePayLaterVisibility = (isHeroVisible) => {
      document.body.classList.toggle(hideClass, isHeroVisible);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          togglePayLaterVisibility(entry.isIntersecting);
        },
        { threshold: 0.01 },
      );

      observer.observe(heroBackground);
      return;
    }

    const updateVisibility = () => {
      const rect = heroBackground.getBoundingClientRect();
      const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      togglePayLaterVisibility(isVisible);
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
  }
});
